module.exports = __webpack_public_path__ + "img/CM-MS-24-Toyota-Playful.40f584aa.jpg";